import { Carousel } from 'foundations-components/transitional/components/Carousel';
import { useCallback, useMemo } from 'react';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { INLINE_LABEL_TYPES } from 'reporting-ui-components/components/inlineLabels/utils';
import useCloneTracker from '../../../../../../hooks/useCloneTracker';
import { reportConfigProcessor } from '../../../insights/utils';
import useConfigSummaryKpiReports from './useConfigSummaryKpiReports';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigReportKPIContent = ({
  appUsageTracker,
  previewReport
}) => {
  const tracker = useCloneTracker(appUsageTracker);
  const processedReport = useMemo(() => {
    return reportConfigProcessor(previewReport);
  }, [previewReport]);
  const kpiReportsForCarousel = useConfigSummaryKpiReports(processedReport);
  const carouselContent = kpiReportsForCarousel.map(report => ({
    // Alt can be left blank because we are not using images in the carousel
    alt: '',
    content: /*#__PURE__*/_jsx(PlatformReportResolver, {
      compact: true,
      inlineLabelTypes: [INLINE_LABEL_TYPES.COMPARE],
      report: report,
      trackingAssetType: "srv-summary-datawell",
      enableReportResolveUsageTracking: false
    })
  }));
  const onStepIndexChange = useCallback(({
    target: {
      value
    }
  }) => {
    tracker.track('srvDatawellCarouselIndexChange', {
      reportType: 'config',
      carouselIndex: value
    });
  }, [tracker]);
  if (kpiReportsForCarousel.length === 1) {
    return /*#__PURE__*/_jsx(PlatformReportResolver, {
      compact: true,
      inlineLabelTypes: [INLINE_LABEL_TYPES.COMPARE],
      report: kpiReportsForCarousel[0],
      trackingAssetType: "srv-summary-datawell",
      enableReportResolveUsageTracking: false
    });
  }
  return /*#__PURE__*/_jsx(Carousel, {
    maxWidth: "100%",
    onStepIndexChange: onStepIndexChange,
    steps: carouselContent,
    padding: "0"
  });
};
export default ConfigReportKPIContent;